export const environment = {
  production: true,
  generateSED: false,
  token: 'token',
  ek: '',
  iv: '',
};
